export const isValidText = (text) => {
    return typeof text === 'string' && text.trim() !== '';
}

export const isValidNumber = (num) => {
    return typeof num === 'number' && !isNaN(num);
}